'use client';

import React from 'react';

interface AppLogoProps {
  variant?: 'light' | 'dark' | 'auto';
  size?: number;
  className?: string;
  onClick?: () => void;
  src?: string;
  text?: string;
  iconName?: string;
}

function AppLogo({
  variant = 'dark',
  size = 120,
  className = '',
  onClick,
}: AppLogoProps) {
  const src =
    variant === 'light' ?'/assets/images/logo-light-1787390941134.png' :'/assets/images/logo-dark-1787402221941.png';

  return (
    <div
      className={`flex items-center ${onClick ? 'cursor-pointer hover:opacity-80' : ''} ${className}`}
      onClick={onClick}
    >
      <img
        src={src}
        alt="Ndoto Logo"
        style={{
          width: size,
          height: Math.round(size * 0.4),
          objectFit: 'contain',
          flexShrink: 0,
          display: 'block',
          opacity: 1,
        }}
      />
    </div>
  );
}

export default AppLogo;
